import { capitaliseFirstLetter } from '../lib/utils';
import { generateListItemsGA4 } from './ga_generate_items';

export const addToCartEventsUA = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'addBasket') {
    const { products, prices, sendAll } = options;
    const {
      id: idVariant,
      brand,
      stock_code: id,
      brand_and_description_short: name,
      primary_root_category: category,
    } = products[0];

    window.dataLayer.push({
      event,
      ecommerce: {
        currencyCode: 'GBP',
        add: {
          products: sendAll
            ? products
            : [
                {
                  id,
                  name,
                  price: prices[idVariant] ? prices[idVariant].price : prices,
                  brand,
                  category,
                  quantity: 1,
                  'id-variant': idVariant,
                },
              ],
        },
      },
    });
  }
};

export const addToCartEventsGA4 = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'add_to_cart_ga4') {
    const { page, products, prices, index } = options;
    const addToCartLocation =
      page === 'Sticky Basket' ? page : `${capitaliseFirstLetter(page)} Page`;
    // TO DO: Add extra properties in Phase 2
    window.dataLayer.push({
      event,
      ecommerce: {
        add_to_cart_location: addToCartLocation,
        items: generateListItemsGA4(page, products, prices, index),
      },
    });
  }
};
